<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <horizontal-stepper 
          :steps="steps" 
          locale= "es"
          @completed-step="completeStep"
          @active-step="isStepActive" 
          @stepper-finished="registrarComprobante"
          :keep-alive="Boolean(true)"
          :top-buttons="Boolean(true)">
        </horizontal-stepper>          
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import HorizontalStepper from 'vue-stepper';
import Credito from './Credito.vue';
import Renglones from './Renglones.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'venta/getField',
  mutationType: 'venta/updateField',
});

export default {
  name: 'ABMCredito',
  components: {
    HorizontalStepper,
    Credito,
    Renglones,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  props: {
    creditoFinanciacion: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      steps: [
          {
              icon: '',
              name: 'venta-credito',
              title: 'Datos del Comprobante',
              subtitle: 'Datos del Comprobante',
              component: Credito,
              completed: false

          },
          {
              icon: '',
              name: 'venta-renglones',
              title: 'Información de Impresión',
              subtitle: 'Ingrese la descripción del comprobante',
              component: Renglones,
              completed: false
          },
      ],
    }
  },
  computed: {
  },
  created() {
    let ventaId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        ventaId = this.$route.params.id;
      }
    }

    // console.log(this.creditoFinanciacion);

    let params = {
      ventaId,
      creditoFinanciacion: this.creditoFinanciacion
    }

    this.showSpinner();
    this.$store.dispatch('venta/inicializarCredito', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());

  },  
  methods: {
    completeStep(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                step.completed = true;
                // console.log(step);
            }
        })
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                if(step.completed === true) {
                    step.completed = false;
                }
            }
        })
    },
    registrarComprobante () {
      this.showSpinner();
      this.$store.dispatch('venta/save')
        .then(() => this.showModalMsj('El comprobante se registró con éxito', this.goList, this.goList, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goList() {
      this.$router.push({ name: 'Facturas' });
    },
  },
  watch: {
  },
}
</script>

<style>
</style>
